import React, { useEffect, useRef, useState } from "react";

const getCurrentMonth = (): {
  monthYear: string;
  days: { day: number; dayOfWeek: string }[];
} => {
  const now = new Date();
  const month = now.toLocaleString("en-US", { month: "long" });
  const year = now.getFullYear();
  const monthYear = `${month} ${year}`;

  // Get the total number of days in the current month
  const totalDays = new Date(year, now.getMonth() + 1, 0).getDate();
  const days: { day: number; dayOfWeek: string }[] = []; // Fixed type

  for (let day = 1; day <= totalDays; day++) {
    const date = new Date(year, now.getMonth(), day);
    const dayOfWeek = date.toLocaleString("en-US", { weekday: "short" });

    days.push({ day, dayOfWeek }); // Fixed push structure
  }

  return { monthYear, days };
};

interface DaysScrollProps {
  selectedDay: number;
  setSelectedDay: (day: number) => void;
}

const DaysScroll: React.FC<DaysScrollProps> = ({
  selectedDay,
  setSelectedDay,
}) => {
  const currentMonth = getCurrentMonth();

  const dateSelected = (day: { day: number; dayOfWeek: string }) => {
    setSelectedDay(day.day);
  };

  const containerRef = useRef<HTMLDivElement>(null);
  const selectedDayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedDayRef.current && containerRef.current) {
      const container = containerRef.current;
      const selectedElement = selectedDayRef.current;

      // Scroll to center the selected day
      container.scrollTo({
        left:
          selectedElement.offsetLeft -
          container.offsetWidth / 2 +
          selectedElement.offsetWidth / 2,
        behavior: "smooth",
      });
    }
  }, [selectedDay]); // Runs when selectedDay changes
  return (
    <div className="mb-10">
      {/* day month n year */}
      <div className="w-full flex justify-end items-center mb-5 pr-6">
        <p className="text-[2.2em] text-[#AFAEB3]">{currentMonth.monthYear}</p>
      </div>

      {/* days */}
      <div
        ref={containerRef}
        className="w-full overflow-x-auto whitespace-nowrap"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        <div className="flex gap-2">
          {currentMonth.days.map((day, index) => {
            const isSelected = selectedDay === day.day;
            return (
              <div
                key={index}
                ref={isSelected ? selectedDayRef : null} // Attach ref only to the selected day
                className={`rounded-full w-[4em] py-4 cursor-pointer flex-shrink-0 text-center flex flex-col justify-center items-center ${
                  isSelected ? "bg-[#3A9437]" : "bg-[#FFFFFF]"
                }  ${index === 0 ? "ml-4" : ""}  ${
                  index === currentMonth.days.length - 1 ? "mr-4" : ""
                }`}
                onClick={() => dateSelected(day)}
              >
                <p
                  className={`text-2xl ${
                    isSelected ? "text-[#FFFFFF]" : "text-[#1B1B1B]"
                  }`}
                >
                  {day.day}
                </p>
                <p
                  className={`text-lg mt-[0.1em] ${
                    isSelected ? "text-white opacity-70" : "text-[#AFAEB3]"
                  }`}
                >
                  {day.dayOfWeek}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DaysScroll;
